/**
 * JSON-API style errors.
 * Taken from the actual API.
 *
 * errors has the format:
 *  date_of_birth: Array<string>
 */
export default class ErrorData {
  errors = {};
  message = '';
  success = false;
}
